import { BASE_LANGUAGE } from '@locales/index';
import { ErrorBoundary } from 'commons/components';
import { i18nProvider } from 'core/i18n/i18n';
import { initializeStencilRouteTransition } from 'core/stencil';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProviders } from './app.providers';
import { AppRouter } from './app.router';
import { GlobalStyle } from './styles';

initializeStencilRouteTransition();
i18nProvider(BASE_LANGUAGE);

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

const App: React.FC = () => (
    <React.Suspense fallback={null}>
        <ErrorBoundary>
            <AppProviders>
                <GlobalStyle />
                <AppRouter />
            </AppProviders>
        </ErrorBoundary>
    </React.Suspense>
);
root.render(<App />);
